import React, { FC } from 'react';
import { Col, Form } from 'react-bootstrap';
import { PaymentModel, PaymentTypesModel } from 'src/pages/blueMoviePlus/query/types';
import { SelectedTickerModel } from 'src/pages/blueMoviePlus/types';
import styles from './RenderPaymentMethods.module.scss';
import { generateImageUrl } from '../../../../../utils/cdnService';
import classNames from 'classnames';

type Props = {
  selectedTicket: SelectedTickerModel;
  payment: PaymentModel;
  selectedType: PaymentTypesModel;
  setSelectedType: (value: PaymentTypesModel) => void;
  hasLastPayments?: boolean;
};
const RenderPaymentMethods: FC<Props> = ({ selectedTicket, payment, setSelectedType, selectedType, hasLastPayments = false }) => {
  const renderPayments = () => {
    // daily product
    const withContrast = true;
    const paymentTypes = selectedTicket.id === 3 
      ? payment?.payment_types 
      : payment?.payment_types.filter((item) => item.name !== 'MicroPayment Sofort');
    
    const totalOptions = (hasLastPayments ? 1 : 0) + (paymentTypes?.length || 0);
    let colSize = 6;
    
    if (totalOptions < 4) {
      if (totalOptions === 3 && !hasLastPayments) {
        colSize = 4;
      } else if (totalOptions === 3 && hasLastPayments) {
        colSize = 3;
      } else if (totalOptions === 2) {
        colSize = hasLastPayments ? 6 : 6;
      }
    }

    if (selectedTicket.id === 3) {
      return payment?.payment_types.map((item) => (
        <Col sm={colSize}>
          <div
            onClick={() => setSelectedType(item)}
            className={classNames(
              styles.typeWrapper,
              item.id === selectedType.id && styles.selected,
              withContrast && styles.contrast
            )}
          >
            <Form.Check
              className={classNames(styles.radioButton, {
                [styles.contrast]: withContrast,
              })}
              type="radio"
              onChange={() => setSelectedType(item)}
              checked={item.id === selectedType.id}
            />
            <img alt="cdn-img" src={generateImageUrl('gcore', 0, 0, item.image)} />
          </div>
        </Col>
      ));
      // this reference to yearly product
    } else if (![4, 23, 10].includes(selectedTicket.id)) {
      return payment?.payment_types
        .filter((item) => item.name !== 'MicroPayment Sofort')
        .map((item) => (
          <Col sm={colSize}>
            <div
              onClick={() => setSelectedType(item)}
              className={classNames(
                styles.typeWrapper,
                item.id === selectedType.id && styles.selected,
                withContrast && styles.contrast
              )}
            >
              <Form.Check
                className={classNames(styles.radioButton, {
                  [styles.contrast]: withContrast,
                })}
                type="radio"
                onChange={() => setSelectedType(item)}
                checked={item.id === selectedType.id}
              />
              <img alt="cdn-img" src={generateImageUrl('gcore', 0, 0, item.image)} />
            </div>
          </Col>
        ));
      // monthly product
    } else {
      return payment?.payment_types
        .filter((item) => item.name !== 'MicroPayment Sofort')
        .map((item) => (
          <Col sm={colSize}>
            <div
              onClick={() => setSelectedType(item)}
              className={classNames(
                styles.typeWrapper,
                item.id === selectedType.id && styles.selected,
                withContrast && styles.contrast
              )}
            >
              <Form.Check
                className={classNames(styles.radioButton, {
                  [styles.contrast]: withContrast,
                })}
                type="radio"
                onChange={() => setSelectedType(item)}
                checked={item.id === selectedType.id}
              />
              <img alt="cdn-img" src={generateImageUrl('gcore', 0, 0, item.image)} />
            </div>
          </Col>
        ));
    }
  };
  return <>{renderPayments()}</>;
};

export default RenderPaymentMethods;
